import { formatNumber } from "../utils";

function CustomPriceDisplay({
  price,
  prefix = "₦",
  displayType = "text",
  text = "",
}) {
  return (
    <div>
      <span>{text}</span>
      {/* <CurrencyFormat
        value={price}
        displayType={displayType}
        thousandSeparator={true}
        prefix={prefix}
        decimalScale={0}
      /> */}
      <span>₦{formatNumber(price ?? 0)}</span>
    </div>
  );
}

export default CustomPriceDisplay;
